import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import { trackInputModality } from "./lib/inputModality";
import "./styles/base.css";

// How the page was last used — the ring round a title a screen focuses on
// opening shows only after a key (lib/inputModality.ts, base.css).
trackInputModality();

const container = document.getElementById("root");
if (!container) throw new Error("Root-Element #root fehlt in index.html.");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
